<template>
    <div class="single-product-item">
        <figure class="product-thumb">
            <div class="ribbon ribbon-top-left" v-if="isNew"><span>new</span></div>
            <div class="ribbon ribbon-top-right" v-if="isWanted"><span>wanted</span></div>
            <a :href="itemUrl" class="d-flex">
                <img class="mx-auto img-fluid" :src="imgSrc" :alt="item.title + ' - Used airsoft equipment'" />
            </a>
        </figure>
        <div class="product-details d-flex justify-content-between flex-column">
            <h2 class="product-title">
                <a :href="itemUrl">{{ item.title }}</a>
            </h2>
            <p>{{ item.summary }}</p>
            <div class="product-description align-self-baseline w-100">
                <template v-if="item.fps">
                    <strong>FPS:</strong> {{ item.fps }}<br>
                </template>
                <div class="d-flex">
                    <div class="product-price mr-auto">{{ item.price | currency }}</div>
                    <div>
                        <i class="fas fa-map-marker-alt"></i>
                        {{ item.county }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            item: {
                required: true,
                type: Object,
            },
        },
        computed: {
            itemUrl() {
                return route('item.show', this.item.slug);
            },

            imgSrc() {
                return '/listing_image/thumbnail/'  + (this.item.photos.length ? this.item.photos[0].filepath : 'placeholder.png');
            },

            isWanted() {
                return this.item.type_id === 2; // todo this shouldn't really be hardcoded
            },

            isNew() {
                return moment(this.item.created_at).isSameOrAfter(moment().subtract(5, 'days')); // todo this shouldn't really be hardcoded
            },
        },
    };
</script>
